/* Top bar: at 820px and below the primary links fold into a menu under the bar.
   The menu button opens it; a link, Escape, a click outside or a wider window
   closes it. */
(() => {
  const nav = document.querySelector("[data-nav]");
  const toggle = nav?.querySelector("[data-nav-toggle]");
  if (!nav || !toggle) return;

  const setOpen = (open) => {
    toggle.setAttribute("aria-expanded", String(open));
    nav.toggleAttribute("data-open", open);
  };

  toggle.addEventListener("click", () => setOpen(toggle.getAttribute("aria-expanded") !== "true"));
  nav.addEventListener("click", (e) => {
    if (e.target.closest(".nav-links a")) setOpen(false);
  });
  document.addEventListener("click", (e) => {
    if (!nav.contains(e.target)) setOpen(false);
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || !nav.hasAttribute("data-open")) return;
    setOpen(false);
    toggle.focus();
  });
  matchMedia("(min-width: 821px)").addEventListener("change", (e) => {
    if (e.matches) setOpen(false);
  });
})();
